import { RiUserSharedLine } from 'react-icons/ri'
import MeritoButton from '../../../../../components/common/MeritoButtons/MeritoButtons'
import { getLocalUser } from '../../../../../components/functions/utilities'
import styles from './ColdState.module.scss'
import ColdStateImg from './../../../../../assets/images/dashboard/dashboardColdStateV2.svg'
import { useNavigate } from 'react-router'
import { TabRole } from '../../../../UserManagement/UserManagement'

const DashboardColdStateV2 = () => {
  const user = getLocalUser()
  const navigate = useNavigate()
  return (
    <div className={styles.body}>
      <div className={styles.leftContainer}>
        <div>
          <p>Hey {user.name.split(' ')[0]},</p>
          <h1>Welcome to Merito!</h1>
        </div>
        <p className={styles.desc}>
          Track sales, ad performance and growth of all your brands in one place. No spreadsheets needed.
        </p>
        <MeritoButton
          type='primary-1'
          size='lg'
          btnText='Invite Brand'
          icon={<RiUserSharedLine />}
          onClick={() => {
            navigate(`/Settings?tab=${TabRole.Brand}&popup=true`)
          }}
        />
      </div>
      <div className={styles.rightContainer}>
        <img src={ColdStateImg} />
      </div>
    </div>
  )
}

export default DashboardColdStateV2